export enum LegalBasis {
  NOT_APPLICABLE = 'not_applicable',
  PUBLIC_INTEREST = 'publicinterest',
  CONTRACT = 'contract',
  CONSENT_OPT_IN = 'consent_optin',
  RESEARCH_LGPD = 'research_lgpd',
  LEGAL_OBLIGATIONS = 'legalobligations',
  HEALTH_LGPD = 'health_lgpd',
  VITAL_INTERESTS = 'vitalinterests',
  CREDIT_LGPD = 'credit_lgpd',
  ALWAYS_OFF = 'always_off',
  LIFE_LGPD = 'life_lgpd',
  LEGITIMATE_INTEREST = 'legitimateinterest',
  CONSENT_OPT_OUT = 'consent_optout',
  DISCLOSURE = 'disclosure',
  LEGITIMATE_INTEREST_OBJECTABLE = 'legitimateinterest_objectable',
}

export const LegalBasisName: Record<LegalBasis, string> = {
  [LegalBasis.NOT_APPLICABLE]: 'Not Applicable',
  [LegalBasis.PUBLIC_INTEREST]: 'Public Interest',
  [LegalBasis.CONTRACT]: 'Contract',
  [LegalBasis.CONSENT_OPT_IN]: 'Consent - Opt In',
  [LegalBasis.RESEARCH_LGPD]: 'Research',
  [LegalBasis.LEGAL_OBLIGATIONS]: 'Legal Obligations',
  [LegalBasis.HEALTH_LGPD]: 'Health Protection',
  [LegalBasis.VITAL_INTERESTS]: 'Vital Interests',
  [LegalBasis.CREDIT_LGPD]: 'Protection of Credit',
  [LegalBasis.ALWAYS_OFF]: 'Always Off',
  [LegalBasis.LIFE_LGPD]: 'Life Protection',
  [LegalBasis.LEGITIMATE_INTEREST]: 'Legitimate Interest - Non-Objectable',
  [LegalBasis.CONSENT_OPT_OUT]: 'Consent - Opt Out',
  [LegalBasis.DISCLOSURE]: 'Disclosure',
  [LegalBasis.LEGITIMATE_INTEREST_OBJECTABLE]: 'Legitimate Interest - Objectable',
}

export const LegalBasisDescription: Record<LegalBasis, string> = {
  [LegalBasis.NOT_APPLICABLE]: 'This purposes is not applicable for this jurisdiction',
  [LegalBasis.PUBLIC_INTEREST]:
    'Necessary for the performance of a task carried out in the public interest or in the exercise of official authority vested in the controller',
  [LegalBasis.CONTRACT]:
    'Necessary for the performance of a contract to which the data subject is party or in order to take steps at the request of the data subject prior to entering into a contract',
  [LegalBasis.CONSENT_OPT_IN]:
    'Data subject has affirmatively and unambiguously consented to the processing for one or more specific purposes',
  [LegalBasis.RESEARCH_LGPD]:
    'Processing for studies by research entities, ensuring whenever possible the anonymization of personal data',
  [LegalBasis.LEGAL_OBLIGATIONS]: 'Necessary for compliance with a legal obligation to which the controller is subject',
  [LegalBasis.HEALTH_LGPD]: 'Processing to protect health, in a procedure carried out by health professionals/entities',
  [LegalBasis.VITAL_INTERESTS]:
    'Necessary to protect the vital interests of the data subject or of another natural person',
  [LegalBasis.CREDIT_LGPD]: 'Processing for the protection of credit',
  [LegalBasis.ALWAYS_OFF]:
    'Data subject has received adequate disclosure describing the processing for one or more specific purposes, and can subsequently opt-out',
  [LegalBasis.LIFE_LGPD]:
    'Processing for the protection of life or physical safety of the data subject or a third party',
  [LegalBasis.LEGITIMATE_INTEREST]:
    'Necessary for the purposes of the legitimate interests pursued by the controller or by a third party, except where such interests are overridden by the interests or fundamental rights and freedoms of the data subject',
  [LegalBasis.CONSENT_OPT_OUT]:
    'Data subject has received adequate disclosure describing the processing for one or more specific purposes, and can subsequently opt-out',
  [LegalBasis.DISCLOSURE]: 'Data subject has been provided with adequate disclosure regarding the processing',
  [LegalBasis.LEGITIMATE_INTEREST_OBJECTABLE]:
    'Necessary for the purposes of the legitimate interests pursued by the controller or by a third party, except where such interests are overridden by the interests or fundamental rights and freedoms of the data subject',
}

export const RequiresOptInLegalBases: LegalBasis[] = [LegalBasis.NOT_APPLICABLE, LegalBasis.CONSENT_OPT_IN]

export const AllowsOptOutLegalBases: LegalBasis[] = [
  LegalBasis.NOT_APPLICABLE,
  LegalBasis.CONSENT_OPT_IN,
  LegalBasis.CONSENT_OPT_OUT,
  LegalBasis.LEGITIMATE_INTEREST_OBJECTABLE,
]
